import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import { WindowObject } from '../model';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  landingUrl = window.location.origin;
  windowObj: WindowObject;
  emailPattern: string = '^[a-zA-Z0-9]+(?:[._%+-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}(?:\\.[a-zA-Z]{2,4})?$'; //NOSONAR
  maxCashflow: number = 1500000;
  oneTimeUserPromoCode: string = '';

  constructor(
    private deviceService: DeviceDetectorService
  ) {
    if (window['org']) {
      this.windowObj = new WindowObject(window['org']);
    }
  }

  /**
   * @description get window object
   */
  get getOrgWindowObject(): WindowObject {
    return this.windowObj;
  }

  get isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }

  /** check is mobile device */
  get isMobileDevice(): boolean {
    return this.deviceService.isMobile();
  }

  /** check is tablet device */
  get isTabletDevice(): boolean {
    return this.deviceService.isTablet();
  }
}
